import { authApiService } from '@/api/authApiService';
import { ApiResponseType, BaseResponseType } from '@/types/sharedTypes';

export type ConfirmSinglePaymentPayloadType = {
  session_id: string;
};

export const confirmSinglePaymentApi = (
  data: ConfirmSinglePaymentPayloadType
): Promise<ApiResponseType<BaseResponseType>> => {
  const uri = '/billing/checkout_session/payment/confirm/';

  return authApiService.POST(uri, data);
};
